import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Phone } from 'lucide-react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';
import { useLanguage } from '@/i18n/LanguageContext';
import { FINANCING_INFO } from '@/data/siteContent';

const Financing = () => {
  const { lang, t } = useLanguage();
  const info = FINANCING_INFO[lang];
  return (
    <PageShell trackPage="/financing">
      <SEO title="Bail Bond Financing & Payment Plans | Amigo's Bail Bonds" description="Flexible, honest bail bond payment plans for Montgomery County families. Call us to discuss your options — no pressure, no judgment." path="/financing" />
      <div className="page-hero">
        <div className="eyebrow">{lang === 'es' ? 'SIN SORPRESAS' : 'NO SURPRISES'}</div>
        <h1 className="section-title">{lang === 'es' ? 'FINANCIAMIENTO Y PLANES DE PAGO' : 'FINANCING & PAYMENT PLANS'}</h1>
      </div>
      <section className="section section--void">
        <div className="container" style={{ maxWidth: 780 }}>
          <p className="section-subtitle mb-8">{info.intro}</p>

          <div className="card-grid card-grid--2 mb-8">
            <div className="info-card">
              <h3 style={{ color: 'var(--text-primary)', margin: '0 0 0.8rem' }}>{lang === 'es' ? 'Qué afecta el costo' : 'What affects the cost'}</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {info.factors.map((f, i) => <li key={i} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.6rem', color: 'var(--text-secondary)', fontSize: '0.92rem' }}><CheckCircle size={15} color="var(--gold)" style={{ flexShrink: 0, marginTop: 2 }} />{f}</li>)}
              </ul>
            </div>
            <div className="info-card">
              <h3 style={{ color: 'var(--text-primary)', margin: '0 0 0.8rem' }}>{lang === 'es' ? 'Nuestras opciones' : 'Our options'}</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {info.options.map((f, i) => <li key={i} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.6rem', color: 'var(--text-secondary)', fontSize: '0.92rem' }}><CheckCircle size={15} color="var(--gold)" style={{ flexShrink: 0, marginTop: 2 }} />{f}</li>)}
              </ul>
            </div>
          </div>

          <div className="text-center">
            <div className="flex gap-4" style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="tel:9368282500" className="btn-red" data-testid="financing-call-cta"><Phone size={16} /> {t('hero.callNow')}</a>
              <Link to="/start-a-bond" className="btn-brass" data-testid="financing-start-bond-cta">{t('hero.startBond')}</Link>
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default Financing;
